<template>
    <div class="navBar">
        <div class="flex align-center justify-center gap-2">
            <img height=30 :src="require('@/assets/img/logo.png')">
            <span class="caption transparent" >{{l.title}}</span>
			<span class="caption transparent">
				by. Cerceis@2022
			</span>
        </div>
        <div class="flex gap justify-end">
            <div class="flex gap-2">
                <button class="btnMini" @click="$router.replace('/')">{{l.play}}</button>
                <button class="btnMini" @click="$router.replace('/deckMaker')">{{l.deckMaker}}</button>
                <button class="btnMini" @click="loadDeck">{{l.load}}</button>
            </div>
            <span>
                <select
                    v-model="currentLanguage"
                    @change="loadLanguageSet(currentLanguage); saveSettings();"
                >
                    <option 
                        v-for="lang in languages"
                        :key="lang"
                    >
                        {{lang}}
                    </option>
                </select>
            </span>
        </div>
        
    </div>
</template>
 
<script setup lang="ts">
import { onMounted } from "vue";
import { l, languages, currentLanguage, loadLanguageSet, Languages } from "@/services/lang-service";
import { loadDeck } from "@/services/spawn-deck-service";

onMounted(()=>{
	const lang = localStorage.getItem("lang");
	if(lang && languages.some(l => l === lang)){
		currentLanguage.value = lang as Languages;
		loadLanguageSet();
	}
})

const saveSettings = () => {
	localStorage.setItem('lang', currentLanguage.value);
}


</script>
 
<style lang="scss" scoped>
.navBar{
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: rgb(255,255,255,.1);
    padding: .5em;
}
</style>
